module.exports = __webpack_public_path__ + "img/au_6.3c283c7f.webp";